import { type ReactNode, Component, type ErrorInfo } from "react";
import { GetWSMgr } from "@/Utils/StateLib";
import { QAlert } from "@coreapp/CoreApp/QAlert";
import { appstr } from "@coreapp/utils/appstr";

type Props = {
  children: ReactNode;
  fallback?: ReactNode;
  onError?: () => void;
};

type State = {
  hasError: boolean;
};

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    const wsMgr = GetWSMgr();
    if (wsMgr == null) return;
    wsMgr.LogSplunk(
      [wsMgr.GetAccountName(), wsMgr.GetUserEmail(), error.stack],
      "ErrorBoundary",
      "Error"
    );
    if (!this.props.fallback) {
      const alert = new QAlert();
      alert.InitAlert(appstr("Alert"), appstr("unknownerrnoemail"), null, wsMgr, true);
    }
    this.props.onError?.();
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback;
    }
    return this.props.children;
  }
}
